import {
  Box,
  Button,
  Card,
  Grid2 as Grid,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { getValue } from "components/shared/CommonFunctions";
import { ReactElement, useState } from "react";
import { saveArticle } from "services/ArticleServices";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const NewArticleModal = ({
  getData,
}: {
  getData: () => void;
}): ReactElement => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [articleData, setArticleData] = useState({
    id: NaN,
    title: "",
    content: "",
    cat_id: 0,
    active: true,
  });

  const handleInputChange = (event: { target: { name: any; value: any } }) => {
    const { name, value } = event.target;
    setArticleData({
      ...articleData,
      [name]: getValue(name, value, articleData.active),
    });
  };

  const handleNewArticle = async () => {
    await saveArticle(articleData);
    getData();
    handleClose();
  };

  return (
    <>
      <Button onClick={handleOpen} variant="contained" color="success">
        New Article
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Article Details
          </Typography>
          <Card>
            <Grid container>
              <Grid size={4}>
                <Typography>Title</Typography>
              </Grid>
              <Grid size={8}>
                <TextField
                  id="title"
                  label="Title"
                  variant="outlined"
                  name="title"
                  value={articleData.title}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid size={4}>
                <Typography>Category</Typography>
              </Grid>
              <Grid size={8}>
                <TextField
                  select
                  name="cat_id"
                  value={articleData.cat_id}
                  onChange={handleInputChange}
                  fullWidth
                  SelectProps={{ native: true }}
                >
                  <option value={0}>-- Select Category --</option>
                  <option value={1}>RENT AN INFLATABLE</option>
                  <option value={2}>BUY AN INFLATABLE</option>
                  <option value={3}>RENT PARTY EQUIPMENT</option>
                </TextField>
              </Grid>

              <Grid size={4}>
                <Typography>Content</Typography>
              </Grid>
              <Grid size={8}>
                <TextField
                  id="content"
                  label="Content"
                  variant="outlined"
                  multiline
                  name="content"
                  value={articleData.content}
                  onChange={handleInputChange}
                  rows={4}
                  fullWidth={true}
                />
              </Grid>
              <Grid size={4}>
                <Typography>Active</Typography>
              </Grid>
              <Grid size={8}>
                <Switch
                  name="active"
                  checked={articleData.active}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid size={8}></Grid>
              <Grid size={2}>
                <Button variant="contained" color="error" onClick={handleClose}>
                  Cancel
                </Button>
              </Grid>
              <Grid size={2}>
                <Button variant="contained" onClick={handleNewArticle}>
                  Save
                </Button>
              </Grid>
            </Grid>
          </Card>
        </Box>
      </Modal>
    </>
  );
};

export default NewArticleModal;
